/**
 * South Korean won.
 */
export var KRW = {
  code: 'KRW',
  base: 10,
  exponent: 0
};